import type { SyberryTodayTaskGroup, SyberryTodayWorkItem } from 'domain/people/syberryToday/types';

const createUngroupedTaskGroup = (tasks: SyberryTodayWorkItem[]): SyberryTodayTaskGroup => ({
  id: '__ungrouped__',
  projectId: '',
  name: 'Other',
  totalCount: tasks.length,
  unreadCount: tasks.filter(task => task.isUnread).length,
});

export const getGroupedTasks = (groups: SyberryTodayTaskGroup[], tasks: SyberryTodayWorkItem[]) => {
  const taskGroupIds = new Set(groups.map(group => group.id));
  const ungroupedTasks = tasks.filter(task => !taskGroupIds.has(task.groupId));
  const groupedTasks = groups
    .map(group => ({
      group,
      tasks: tasks.filter(task => task.groupId === group.id),
    }))
    .filter(taskGroup => taskGroup.tasks.length > 0);

  return ungroupedTasks.length
    ? [...groupedTasks, { group: createUngroupedTaskGroup(ungroupedTasks), tasks: ungroupedTasks }]
    : groupedTasks;
};
